export const CP_ORDER_TABLE_ALIAS = 'cp_orders';

export const MAX_ORDER_VIEW_COUNT = 11;

export const SORTABLE_INITIAL_STATE = {
    isOpen: false,
    data: [],
};

export const BULK_SELECTION_INITIAL_STATE = {
    isOpen: false,
    data: [] as number[],
};

export const DEFAULT_ORDER_TAB_VALUES = ['all', 'booked', 'dispatched', 'in-transit', 'delivered', 'completed'];

export const CP_ORDER_DEFAULT_COLUMNS = [
    { id: 'orderId', name: 'Order #', visible: true, displayOrder: 1 },
    { id: 'salesRep', name: 'Created By', visible: true, displayOrder: 2 },
    { id: 'orderStatus', name: 'Status', visible: true, displayOrder: 3 },
    { id: 'orderType', name: 'Type', visible: true, displayOrder: 4 },
    { id: 'shipperFullAddress', name: 'Origin', visible: true, displayOrder: 5 },
    { id: 'consigneeFullAddress', name: 'Destination', visible: true, displayOrder: 6 },
    { id: 'createdAt', name: 'Created', visible: true, displayOrder: 7 },
    { id: 'handlingUnits', name: 'Handling Unit', visible: true, displayOrder: 8 },
    { id: 'totalWeight', name: 'Total Weight', visible: true, displayOrder: 9 },
    { id: 'totalCost', name: 'Cost', visible: true, displayOrder: 10 },
    { id: 'updatedAt', name: 'Last Modified', visible: true, displayOrder: 11 },
    { id: 'pickupDate', name: 'Pickup Date', visible: false, displayOrder: 12 },
    { id: 'deliveryDate', name: 'Delivery Date', visible: false, displayOrder: 13 },
    { id: 'carrier', name: 'Carrier', visible: false, displayOrder: 14 },
    { id: 'bolNumber', name: 'BOL #', visible: false, displayOrder: 15 },
    { id: 'refNumber', name: 'Reference #', visible: false, displayOrder: 16 },
    { id: 'linearFootage', name: 'Linear Feet', visible: false, displayOrder: 17 },
    { id: 'equipmentType', name: 'Equipment', visible: false, displayOrder: 18 },
];

export const COLUMN_CLASSNAME_MAP: Record<string, string> = {
    // Fluid width, 1:1 with wal-frontend-v2's Orders listing (NewOrderRow `max-w-px min-w-[208px]`).
    orderId: 'max-w-px min-w-[200px]',
    salesRep: 'min-w-[150px] max-w-[150px] w-[150px]',
    orderStatus: 'min-w-[125px] max-w-[125px] w-[125px]',
    orderType: 'min-w-[100px] max-w-[100px] w-[100px]',
    shipperFullAddress: 'text-xs xxl:max-w-[170px] xxl:w-[170px] xxl:min-w-[170px] w-40 max-w-40 min-w-40',
    consigneeFullAddress: 'text-xs xxl:max-w-[170px] xxl:w-[170px] xxl:min-w-[170px] w-40 max-w-40 min-w-40',
    createdAt: 'min-w-[165px] w-[165px] max-w-[165px]',
    handlingUnits: 'min-w-[155px] w-[155px] max-w-[155px]',
    totalWeight: 'min-w-[140px] w-[140px] max-w-[140px]',
    totalCost: 'min-w-[145px] w-[145px] max-w-[145px]',
    updatedAt: 'min-w-[165px] w-[165px] max-w-[165px]',
    pickupDate: 'min-w-[155px] w-[155px] max-w-[155px]',
    deliveryDate: 'min-w-[155px] w-[155px] max-w-[155px]',
    carrier: 'min-w-[190px] max-w-[190px]',
    bolNumber: 'min-w-[145px] w-[145px] max-w-[145px]',
    refNumber: 'min-w-[145px] w-[145px] max-w-[145px]',
    linearFootage: 'min-w-[130px] w-[130px] max-w-[130px]',
    equipmentType: 'min-w-[145px] w-[145px] max-w-[145px]',
    action: 'min-w-[38px] max-w-[38px] w-[38px] table-cell-with-tooltip',
};

export const COLUMN_TRANSLATION_MAP: Record<string, string> = {
    orderStatus: 'Common.Status',
    orderType: 'Common.Type',
    shipperFullAddress: 'Common.Origin',
    consigneeFullAddress: 'Common.Destination',
    createdAt: 'Common.Order_Created',
    handlingUnits: 'Common.Handling_Unit',
    totalWeight: 'Common.Total_Weight',
    totalCost: 'Common.Cost',
    updatedAt: 'Common.Order_Updated',
};

import { IDimensionProps } from './order.interface';

export const classOptions = [
    {
        label: 'LTL',
        value: 'ltl',
    },
    {
        label: 'FTL',
        value: 'ftl',
    },
];

export const initAction = {
    mode: null,
    shipper: false,
    consignee: false,
    type: null,
    status: null,
    isEditMode: false,
    url: null,
    carrierId: null,
};

export const dimensionObj: IDimensionProps = {
    handlingUnit: undefined,
    handlingUnitNo: undefined,
    length: undefined,
    width: undefined,
    height: undefined,
    weight: undefined,
    totalWeight: undefined,
    freightClass: undefined,
    refNumber: undefined,
    isStack: true,
    itemClassForDayross: 0,
    description: undefined,
    unitPrice: '',
    unitPriceCurrency: '',
};

// Order Status enum values for API
export const ORDER_STATUS = {
    ALL: 'all',
    BOOKED: 'booked',
    DELIVERED: 'delivered',
    DISPATCHED: 'dispatched',
    IN_TRANSIT: 'in-transit',
    COMPLETED: 'completed',
};

// Status options for filter dropdown
export const ORDER_STATUS_OPTIONS = [
    {
        label: 'All',
        value: ORDER_STATUS.ALL,
    },
    {
        label: 'Booked',
        value: ORDER_STATUS.BOOKED,
    },
    {
        label: 'Delivered',
        value: ORDER_STATUS.DELIVERED,
    },
    {
        label: 'Dispatched',
        value: ORDER_STATUS.DISPATCHED,
    },
    {
        label: 'In-Transit',
        value: ORDER_STATUS.IN_TRANSIT,
    },
    {
        label: 'Completed',
        value: ORDER_STATUS.COMPLETED,
    },
];

// Classification options for filter dropdown
export const ORDER_CLASSIFICATION_OPTIONS = [
    {
        label: 'LTL',
        value: 'ltl',
    },
    {
        label: 'FTL',
        value: 'ftl',
    },
];

export const ORDER_DOCUMENT_TYPE: { [key: string]: string } = {
    CUSTOMS_DOCUMENT: 'customs_document',
    BOL: 'BOL',
    RATE_CONFIRMATION: 'rate_confirmation',
    POD: 'POD',
    COMMERCIAL_INVOICE: 'commercial_invoice',
    NEW_DOCUMENTS: 'new_documents',
    CUSTOMER_INVOICE: 'customer_invoice',
    SHIPMENT: 'shipment',
    OTHER: 'other',
};

export type OrderKeysType = 'shipper_details' | 'consignee_details' | 'load_details' | 'order_details' | 'documents' | 'review_finalize';
